/**
 * Storage names to save in local storage
 */

export const ACCESS_TOKEN_KEY: string = "access";
export const REFRESH_TOKEN_KEY: string = "refresh";
export const USER_ROLE: string = "userRole";
export const USER: string = "user";
